<template>
  <div class="history-component" ref="historyComponent">
    <div class="area">
      <div class="row history-container" v-animated-show="utils.handleScroll">
        <h1 v-html="title" class="col-12 centered"></h1>
        <div class="float-art-left"></div>
        <section
          class="list-section-banner"
          v-for="(l, i) in list"
          ref="history"
          :key="i"
          :class="[
            {
              greyscale: greyscale[i],
            },
          ]"
        >
          <div class="content">
            <Description
              class
              :class="['mini']"
              ref="bannerDescription"
              :isMoreTop="true"
              :title="l.title"
              :desc="l.desc"
              :button="l.button"
              :href="l.href"
              :icon="l.icon"
              v-if="l.title"
            />
          </div>
          <div class="date" v-html="l.date"></div>
          <div class="art-img">
            <img :src="l.img.src" :alt="l.img.alt" class="art" />
          </div>
        </section>
        <ScrollMarker
          :bottomCircle="true"
          :scrollHeight="scrollMarkerHeight"
          @scrolled="
            e => {
              onChange(e);
            }
          "
        />
      </div>
    </div>
  </div>
</template>

<script>
import ScrollMarker from "../components/ScrollMarker";
import utils from "../utils";
export default {
  name: "NewsList",
  props: {
    title: String,
    button: String,
    list: Array,
  },
  data() {
    return {
      utils: utils,
      greyscale: [],
      currentY: 0,
      scrollMarkerHeight: -1,
    };
  },
  methods: {
    onChange(currentY) {
      this.currentY = currentY;
    },
    onScroll() {
      this.$refs.history.forEach((element, index) => {
        let top = element.getBoundingClientRect().top;
        this.greyscale[index] = top > this.currentY;
      });
      this.greyscale = [...this.greyscale];
      this.scrollMarkerHeight =
        this.$refs.historyComponent !== undefined
          ? this.$refs.historyComponent.getBoundingClientRect().height + 370
          : document.getElementById("page-container").scrollHeight;
    },
  },
  beforeDestroy() {
    if (document.getElementById("page-container")) {
      document
        .getElementById("page-container")
        .removeEventListener("scroll", this.onScroll);
    }
  },
  mounted() {
    document
      .getElementById("page-container")
      .addEventListener("scroll", this.onScroll);
    this.list.forEach(() => {
      this.greyscale.push(true);
    });
  },
  components: { ScrollMarker },
};
</script>

<style lang="scss">
.history-component {
  @extend %page-block;
  @media all and (max-width: $md) {
    padding-bottom: 78px;
  }
  padding-bottom: 78px;
  h1 {
    @media all and (max-width: $md) {
      margin-bottom: 78px;
    }
    margin-bottom: 100px;
  }
  .history-container {
    @media all and (max-width: $md) {
      grid-row-gap: 36px;
    }
    grid-row-gap: 0px;
  }
  .list-section-banner {
    @media all and (max-width: $md) {
      grid-column: 1 / span 12;
      grid-template-columns: repeat(12, minmax(0, 1fr));
      grid-template-rows: 40px auto auto;
      grid-gap: 0 16px;
    }
    transition: color 0.5s;
    grid-column: 2 / span 10;
    display: grid;
    grid-template-rows: 30px auto;
    grid-template-columns: repeat(10, minmax(0, 1fr));
    grid-gap: 0 26px;
    .content {
      @media all and (max-width: $md) {
        grid-row: 3;
        grid-column: 1 / span 12;
        margin-right: 0;
        text-align: center;
        padding-top: 35px;
        margin-top: 0;
      }
      background: $bg-main;
      z-index: 1;
      grid-row: 2;
      grid-column: 1 / span 4;
      text-align: right;
      margin-right: -26px;
      margin-top: 35px;
    }
    .description.mini {
      .desc {
        line-height: 1.5em;
        padding-bottom: 15px;
      }
    }
    .date {
      @media all and (max-width: $md) {
        grid-row: 1;
        grid-column: 1 / span 12;
      }
      @extend %text-mini;
      background: $bg-main;
      grid-row: 1;
      grid-column: 5 / span 2;
      text-align: center;
      z-index: 1;
      position: relative;
      display: grid;
      align-content: center;
      align-items: center;
    }
    .art-img {
      @media all and (max-width: $md) {
        grid-row: 2;
        grid-column: 1 / span 12;
        margin-left: 0;
        justify-self: center;
        justify-content: center;
        justify-items: center;
        text-align: center;
      }
      transition: filter 0.5s;
      z-index: 1;
      background: $bg-main;
      grid-row: 2;
      grid-column: 7 / span 4;
      img {
        @media all and (max-width: $md) {
          height: auto;
          max-width: 400px;
        }
        height: 211px;
        object-fit: cover;
        width: 100%;
        max-width: 100%;
        border-radius: 10px;
        transition: box-shadow 0.5s;
        box-shadow: $float-shadow;
      }
      margin-left: -26px;
    }

    &.greyscale {
      @media all and (max-width: $md) {
        color: unset;
      }
      color: $bg-grey-dark2;
      .more {
        @media all and (min-width: $md + 1px) {
          color: $bg-grey-dark2 !important;
        }
      }
      .art-img {
        // @media all and (max-width: $md) {
        //   filter: unset;
        //   -webkit-filter: unset;
        //   -moz-filter: unset;
        //   -ms-filter: unset;
        //   -o-filter: unset;
        //   filter: unset;
        // }
        filter: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg'><filter id='grayscale'><feColorMatrix type='matrix' values='0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0 1 0'/></filter></svg>#grayscale");
        -webkit-filter: grayscale(100%);
        -moz-filter: grayscale(100%);
        -ms-filter: grayscale(100%);
        -o-filter: grayscale(100%);
        filter: gray;
        img {
          box-shadow: unset;
        }
      }
    }
  }
  position: relative;
  .scroll-marker {
    top: 100px;
    position: absolute;
    bottom: -54px;
    grid-column: 7;
    margin-left: -8px;
    z-index: 0;
    @media all and (max-width: $md) {
    }
  }
  .float-art-left {
    @media all and (max-width: $md) {
      display: none;
    }
    position: absolute;
    background: url(../assets/photos/history/rozh1_1@2x.png) no-repeat right
      center;
    left: calc((1088px - 100vw) / 2 - 110px);
    width: calc((100vw - 1088px) / 3 + 240px);
    height: calc((100vw - 1088px) / 3 + 240px);
    max-width: 600px;
    max-height: 600px;
    background-size: contain;
    top: 0;
  }
}
</style>
